import { Injectable } from '@angular/core';
import { PackingBoxViewAuthService } from '../../../views/packing-box/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HosesAuthPackingBoxService extends PackingBoxViewAuthService {
  override createLabel(): boolean {
    return this.lookForRolesNeeded([
      'Admin',
      'Chief',
      'LabelOperator',
      'HosesLabelOperator',
      'HosesQC',
    ]);
  }
  override allowPrintingStation(): boolean {
    return this.createLabel() || this.lookForRolesNeeded(['HosesTrimming']);
  }
}
